/*
 * Kontaktní formulář s volitelnou přílohou fotky.
 * Nativní Shopify contact form neumí přílohy, proto se odesílá přes fetch()
 * na Cloudflare Worker (POST {worker_url}/contact), který fotku uloží do
 * Shopify Files a zapíše záznam do Google Sheet.
 */
(function () {
  'use strict';

  var form = document.getElementById('FlowikContactForm');
  if (!form) return;

  var workerUrl = form.dataset.workerUrl;
  var submitBtn = form.querySelector('[data-flowik-contact-submit]');
  var confirmEl = document.querySelector('[data-flowik-contact-confirm]');
  var errorEl = document.querySelector('[data-flowik-contact-error]');
  var photoInput = form.querySelector('#ContactForm-photo');

  function showError(msg) {
    if (errorEl) { errorEl.textContent = msg; errorEl.classList.remove('is-hidden'); }
  }

  /* Fotka jako base64. HEIC nelze přes canvas přečíst v Chrome, posílá se beze změny. */
  function readFileAsBase64(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () {
        resolve(String(reader.result).split(',')[1]);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  function mediaTypeFor(file) {
    if (file.type === 'image/png') return 'image/png';
    if (file.type === 'image/webp') return 'image/webp';
    return 'image/jpeg';
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (errorEl) errorEl.classList.add('is-hidden');

    if (form.website.value) return; // honeypot

    if (!workerUrl) {
      showError('Formulář zatím není propojen se serverem. Napište nám prosím na telefon.');
      return;
    }

    var payload = {
      name: form.name.value,
      email: form.email.value,
      message: form.message.value,
      website: form.website.value,
    };

    var file = photoInput && photoInput.files[0];
    var maxBytes = 10 * 1024 * 1024;

    if (file && file.size > maxBytes) {
      showError('Fotka je větší než 10 MB. Zkuste ji prosím zmenšit.');
      return;
    }

    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Odesílám...'; }

    var filePromise = file ? readFileAsBase64(file) : Promise.resolve(null);

    filePromise
      .then(function (base64) {
        if (base64) {
          payload.image = base64;
          payload.media_type = mediaTypeFor(file);
        }
        return fetch(workerUrl.replace(/\/$/, '') + '/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
      })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.error) { showError(data.error); return; }
        form.classList.add('is-hidden');
        if (confirmEl) confirmEl.classList.add('is-visible');
      })
      .catch(function () {
        showError('Zprávu se nepodařilo odeslat. Zkontrolujte připojení a zkuste to znovu.');
      })
      .finally(function () {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Odeslat zprávu'; }
      });
  });
})();
